export const toTitleCaseReplaceSeparator = (phrase, separator) => {
  phrase = phrase?.replaceAll(separator, ' ');
  return phrase
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word) => word.charAt(0)?.toUpperCase() + word.slice(1))
    ?.join(' ');
};
